import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a90d0c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "neutralize-ribbon" }
const _hoisted_2 = { class: "main mb-5" }
const _hoisted_3 = { class: "container mt-5" }
const _hoisted_4 = { class: "columns" }
const _hoisted_5 = { class: "column is-half" }
const _hoisted_6 = { class: "accounts card custom-card custom-card-padding" }
const _hoisted_7 = {
  key: 0,
  class: "mt-5 accounts card custom-card custom-card-padding"
}
const _hoisted_8 = {
  key: 0,
  class: "column is-half"
}
const _hoisted_9 = { class: "accounts card custom-card custom-card-padding" }
const _hoisted_10 = {
  key: 0,
  class: "action-footer-container"
}
const _hoisted_11 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheCurrencyList = _resolveComponent("TheCurrencyList")!
  const _component_PendingAccounts = _resolveComponent("PendingAccounts")!
  const _component_PendingCredits = _resolveComponent("PendingCredits")!
  const _component_TheDashboardFooter = _resolveComponent("TheDashboardFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$gettext("Admin")), 1)
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_TheCurrencyList, {
                  onRefreshTransaction: _ctx.refreshTransaction,
                  onRefreshAccounts: _ctx.refreshAccounts,
                  onRefreshCurrency: _ctx.refreshCurrency,
                  onCurrencySelected: _ctx.currencySelected,
                  refreshToggle: _ctx.refreshCurrencyToggle,
                  currency: _ctx.currency
                }, null, 8, ["onRefreshTransaction", "onRefreshAccounts", "onRefreshCurrency", "onCurrencySelected", "refreshToggle", "currency"])
              ]),
              (_ctx.hasUserAccountValidationRights)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_PendingAccounts, {
                      refreshToggle: _ctx.refreshAccountsToggle,
                      onHasAccounts: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPendingAccounts = $event))
                    }, null, 8, ["refreshToggle"])
                  ], 512)), [
                    [_vShow, _ctx.showPendingAccounts]
                  ])
                : _createCommentVNode("", true)
            ]),
            (_ctx.hasCreditRequestValidationRights)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_PendingCredits, {
                      refreshToggle: _ctx.refreshTransactionsToggle,
                      onHasCredits: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPendingCredits = $event)),
                      onRefreshTransaction: _ctx.refreshTransaction,
                      onRefreshAccounts: _ctx.refreshAccounts
                    }, null, 8, ["refreshToggle", "onRefreshTransaction", "onRefreshAccounts"])
                  ])
                ], 512)), [
                  [_vShow, _ctx.showPendingCredits]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.hasInspectRights)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_TheDashboardFooter, {
                  isAdmin: true,
                  currency: _ctx.currency,
                  onRefreshTransaction: _ctx.refreshTransaction,
                  onRefreshAccounts: _ctx.refreshAccounts,
                  onRefreshCurrency: _ctx.refreshCurrency
                }, null, 8, ["currency", "onRefreshTransaction", "onRefreshAccounts", "onRefreshCurrency"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}